
import setFaq from './pages/faq';
import handleTermsTabs from './pages/abas';
//addImports

import setTopBar from "../components/topBar";

const Page = {
  init: function () {
    var _this = this;

    setTopBar();

    
		setFaq()
		handleTermsTabs()
		//calls

  },
};

window.addEventListener('DOMContentLoaded', () => {
  Page.init()
})
